/* 
  ### Customized Chart Components ### 
  Predefined component's behaviors for the Dashboard
*/

// 01_Summaries 
import Sundries2               from '../01_Summaries/Sundries2/index.vue'
import Simple_A                from '../01_Summaries/Simple_A/index.vue'

import Status_A                from '../01_Summaries/Status_A/index.vue'
import Status_B                from '../01_Summaries/Status_B/index.vue'
import Status_Group            from '../01_Summaries/Status_Group/index.vue'
import Status_Punch            from '../01_Summaries/Status_Punch/index.vue'
import Progress_A              from '../01_Summaries/Progress_A/index.vue'
import Progress_B              from '../01_Summaries/Progress_B/index.vue'
import Progress_C              from '../01_Summaries/Progress_C/index.vue'
import Cube_A                  from '../01_Summaries/Cube_A/index.vue'
import Cube_B                  from '../01_Summaries/Cube_B/index.vue'
import Cube_C                  from '../01_Summaries/Cube_C/index.vue'
import Cube_SC                 from '../01_Summaries/Cube_SC/index.vue'
import Donuts                  from '../01_Summaries/Donuts/index.vue'
import Donut_Status            from '../01_Summaries/Donut_Status/index.vue'

import Sentence                 from '../01_Summaries/Sentence/index.vue'
import WeekStatus              from '../01_Summaries/WeekStatus/index.vue'
 

// 02 DataTables 
import TBL_Integration         from '../02_DataTables/Integration/index.vue'
import TBL_Scrollbar           from '../02_DataTables/Scrollbar/index.vue'
import TBL_Progress            from '../02_DataTables/Progress/index.vue'
import TBL_Punch               from '../02_DataTables/Punch/index.vue'

// 03 Primavera
import P6_SCURVE               from '../03_Primavera/SCurve/index.vue'
import P6_TABLE_EL             from '../03_Primavera/Table_EL/index.vue'
import P6_TABLE_MD             from '../03_Primavera/Table_MD/index.vue'
import P6_TUBE_EL              from '../03_Primavera/Tube_EL/index.vue'
import P6_TUBE_MD              from '../03_Primavera/Tube_MD/index.vue'
import P6_GAUGE_MD             from '../03_Primavera/Gauge_MD/index.vue'

// 04 Histogram 
import HIS_AXIS_NORMAL         from '../04_Histogram/Axis/Axis_Normal/index.vue'
import HIS_AXIS_MINI           from '../04_Histogram/Axis/Axis_Mini/index.vue'
import HIS_AXES_MINI           from '../04_Histogram/Axes/Axes_Mini/index.vue'
import HIS_AXES_NORMAL         from '../04_Histogram/Axes/Axes_Normal/index.vue'
import HIS_AXES_STACK          from '../04_Histogram/Axes/Axes_Stack/index.vue'
import HIS_AXES_PUNCH          from '../04_Histogram/Axes/Axes_Punch/index.vue'
import HIS_AXES_PUNCH_MINI     from '../04_Histogram/Axes/Axes_Punch_Mini/index.vue'
import HIS_BAR_VER_MULTI       from '../04_Histogram/Bar/Ver_Multi/index.vue'
import HIS_BAR_VER_STACK       from '../04_Histogram/Bar/Ver_Stack/index.vue'
import HIS_BAR_STACK_STATUS    from '../04_Histogram/Bar/Stack_Status/index.vue'
import HIS_BAR_HOZ_MULTI       from '../04_Histogram/Bar/Hoz_Multi/index.vue'
import HIS_BAR_TRENDS          from '../04_Histogram/Bar/WeekTrends/index.vue'
import HIS_MULTI_NORMAL        from '../04_Histogram/Multi/Multi_Normal/index.vue'
import HIS_MULTI_LEGEND        from '../04_Histogram/Multi/Multi_Legends/index.vue'
import HIS_MULTI_SELECT        from '../04_Histogram/Multi/Multi_Select/index.vue'

// 04 Charts 
import CHT_RADAR               from '../05_Charts/Radar/index.vue'
import CHT_PIE                 from '../05_Charts/Pie/index.vue'
import CHT_DONUT               from '../05_Charts/Donut/index.vue'
import CHT_TUBE                from '../05_Charts/Tube/index.vue'
import CHT_GAUGE               from '../05_Charts/Gauge/index.vue'
import CHT_GAUGE_FC            from '../05_Charts/Gauge_FC/index.vue'
import CHT_GAUGE_QTY           from '../05_Charts/Gauge_Qty/index.vue'
import CHT_SKYLINE_MINI        from '../05_Charts/Skyline_Mini/index.vue'

// 06 Reports
import RPT_SCURVE_MS           from '../06_Reports/Planning/SCurve_MS/index.vue'
import RPT_PROGRESS_EL         from '../06_Reports/Planning/Progress_EL/index.vue'
import RPT_SCURVE_BLOCK        from '../06_Reports/Construction/SCurve_Block/index.vue'
import RPT_ERECTION_STATUS     from '../06_Reports/Construction/Erection_Status/index.vue'
import RPT_SYSTEM_STATUS       from '../06_Reports/SystemCompletion/System_Status/index.vue'

// Viewer
import Filter_Viewer           from '../00_System/Filter_Viewer/index.vue'
import Text_Editor             from '../00_System/TextEditor/index.vue'
import SYS_CP_Status           from '../00_System/Component_Status/index.vue'

export default {

  // 01_Summaries
  Sundries2,
  Simple_A,

  Status_A,
  Status_B,
  Status_Group,
  Status_Punch,
  Progress_A,
  Progress_B,
  Progress_C,
  Cube_A,
  Cube_B,
  Cube_C,
  Cube_SC,
  Donuts,
  Donut_Status,
  Sentence,
  WeekStatus,
  
  // 02 DataTables
  TBL_Integration,
  TBL_Scrollbar,
  TBL_Progress,
  TBL_Punch,

  // 03 Primavera
  P6_SCURVE,
  P6_TABLE_EL,
  P6_TABLE_MD,
  P6_TUBE_EL,
  P6_TUBE_MD,
  P6_GAUGE_MD,
  
  // 04 Charts
  HIS_AXIS_NORMAL,
  HIS_AXIS_MINI,
  HIS_AXES_MINI,
  HIS_AXES_NORMAL,
  HIS_AXES_STACK,
  HIS_AXES_PUNCH,
  HIS_AXES_PUNCH_MINI,
  HIS_BAR_VER_MULTI,
  HIS_BAR_VER_STACK,
  HIS_BAR_STACK_STATUS,
  HIS_BAR_HOZ_MULTI,
  HIS_BAR_TRENDS,
  HIS_MULTI_NORMAL,
  HIS_MULTI_LEGEND,
  HIS_MULTI_SELECT,

  // 05 Charts 
  CHT_RADAR,
  CHT_PIE,
  CHT_DONUT,
  CHT_TUBE,
  CHT_GAUGE,
  CHT_GAUGE_FC,
  CHT_GAUGE_QTY,
  CHT_SKYLINE_MINI,
  
  // 06 Report
  RPT_SCURVE_MS,
  RPT_PROGRESS_EL,
  RPT_SCURVE_BLOCK,
  RPT_ERECTION_STATUS,
  RPT_SYSTEM_STATUS,

  // System
  Filter_Viewer,
  Text_Editor,
  SYS_CP_Status,


}
